module.exports = __webpack_public_path__ + "img/dat03.787c3807.png";